<template>
  <svg fill="none" viewBox="4 4 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.24001 14.0463C6.24001 18.3978 9.78689 21.9447 14.1463 21.9447C15.9041 21.9447 17.5212 21.3666 18.8338 20.39L23.9822 25.5462C24.1775 25.7494 24.4509 25.8509 24.7322 25.8509C25.3494 25.8509 25.7634 25.3822 25.7634 24.7962C25.7634 24.5072 25.6619 24.2572 25.4744 24.0619L20.3494 18.9134C21.4119 17.5775 22.0525 15.8822 22.0525 14.0463C22.0525 9.68689 18.5056 6.14001 14.1463 6.14001C9.78689 6.14001 6.24001 9.68689 6.24001 14.0463ZM7.70095 14.0463C7.70095 10.4916 10.5916 7.60095 14.1463 7.60095C17.7009 7.60095 20.5838 10.4916 20.5838 14.0463C20.5838 17.5931 17.7009 20.4838 14.1463 20.4838C10.5916 20.4838 7.70095 17.5931 7.70095 14.0463Z"
      fill="#424959"
    />
  </svg>
</template>
